<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="new-survey">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm8 md7 elevation-6>
                <div class="sub-window">
                    <!-- <v-toolbar dense dark color="teal darken-2">
                        <v-toolbar-title>Nueva encuesta &nbsp;&nbsp;</v-toolbar-title>
                    </v-toolbar> -->

                    <v-container pa-2 grid-list-md>
                        <v-card class="mx-auto" width="800">
                            <v-img
                                class="teal--text text--lighten-3 align-end"
                                :height="imgHeight"
                                src="@/assets/start.jpg"
                                lazy-src="@/assets/start-blur.jpg"
                                gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                            >
                                <v-card-title class="headline">Nueva Encuesta</v-card-title>
                            </v-img>

                            <v-card-text>
                               <v-container>
                                   <v-layout row wrap justify-space-between>
                                        <v-flex xs12 sm6 md5>
                                            <v-text-field
                                                :dense="bDense"
                                                prepend-icon="mdi-calendar-month"
                                                name="name"
                                                label="Fecha de evaluación"
                                                v-model="this.dToday"
                                                type="text"
                                                readonly
                                                color="teal darken-3"
                                                
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 md5>
                                            <v-text-field
                                                :dense="bDense"
                                                 prepend-icon="mdi-clipboard-pulse-outline"
                                                name="name"
                                                label="Encuestador"
                                                v-model="userName"
                                                type="text"
                                                :readonly="true"
                                                ref="name_field"
                                                color="teal darken-3"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap justify-space-between>
                                        <v-flex xs12 sm12 md4 lg3>
                                            <v-text-field
                                                :dense="bDense"
                                                prepend-icon="mdi-account"
                                                name="name"
                                                label="Apellido paterno"
                                                v-model="pLastname"
                                                type="text"
                                                :readonly="false"
                                                ref="lastname_field"
                                                color="teal darken-3"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12 md4 lg3>
                                            <v-text-field
                                                :dense="bDense"
                                                name="name"
                                                label="Apellido materno"
                                                v-model="mLastname"
                                                type="text"
                                                :readonly="false"
                                                color="teal darken-3"
                                            ></v-text-field>
                                        </v-flex>
                                            <v-flex xs12 sm12 md4 lg3>
                                            <v-text-field
                                                :dense="bDense"
                                                name="name"
                                                label="Nombre"
                                                v-model="name"
                                                type="text"
                                                :readonly="false"
                                                color="teal darken-3"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap justify-space-between>
                                        <v-flex xs12 sm12 md4 lg3>
                                            <v-select
                                                :dense="bDense"
                                                prepend-icon="mdi-account-child"
                                                :items="ageRanges"
                                                item-text="rangoEdad"
                                                item-value="rangoedadid"
                                                label="Edad"
                                                v-model="ageID"
                                                color="teal darken-3"
                                                item-color="teal darken-3"
                                                no-data-text="No hay rangos de edad registrados."
                                                :readonly="false"
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs12 sm12 md4 lg3>
                                            <v-select
                                                :dense="bDense"
                                                prepend-icon="mdi-gender-male-female"
                                                :items="genders"
                                                item-text="genero"
                                                item-value="generoid"
                                                label="Sexo"
                                                v-model="sexID"
                                                color="teal darken-3"
                                                item-color="teal darken-3"
                                                :readonly="false"
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs12 sm12 md4 lg4>
                                            <v-select
                                                :dense="bDense"
                                                prepend-icon="mdi-account-tie"
                                                :items="organizationalLevels"
                                                item-text="nivelOrganizacional"
                                                item-value="nivelorganizacionalid"
                                                label="Nivel organizacional"
                                                v-model="orgLevelID"
                                                color="teal darken-3"
                                                item-color="teal darken-3"
                                                no-data-text="No hay niveles registrados."
                                                :readonly="false"    
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap justify-space-between>
                                        <v-flex xs12 sm12 md6 lg6>
                                            <v-text-field
                                                :dense="bDense"
                                                prepend-icon="mdi-email"
                                                name="email"
                                                label="Correo electrónico"
                                                v-model="email"
                                                type="text"
                                                :readonly="false"
                                                color="teal darken-3"
                                            ></v-text-field>
                                        </v-flex>
                                         <v-flex xs12 sm12 md4 lg3>
                                            <v-select
                                                :dense="bDense"
                                                prepend-icon="mdi-translate"
                                                :items="languages"
                                                item-text="idioma"
                                                item-value="idiomaid"
                                                label="Idioma"
                                                v-model="languageID"
                                                color="teal darken-3"
                                                item-color="teal darken-3"
                                                no-data-text="No hay idiomas registrados."
                                                :readonly="false"    
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                               </v-container>
                            </v-card-text>
                        </v-card>

                        <v-layout align-center justify-end row fill-height>
                            <v-flex xs12 sm8 class="text-xs-center text-end">
                                <v-btn
                                    color="teal darken-3"
                                    class="text-none"
                                    text
                                    @click="onStart"
                                >Comenzar</v-btn>
                                <v-btn
                                    color="pink darken-1"
                                    class="text-none"
                                    text
                                    @click="onCancel"
                                >Cancelar</v-btn>
                            </v-flex>
                        </v-layout>
                        <!-- Modal para confirmar cancelación: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bCancelDlg" persistent :width="modalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Nueva encuesta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-exit-run</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <v-container>
                                            <v-layout row>
                                                <v-flex x12 class="text-xs-center">
                                                    <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    x12
                                                    class="text-xs-center"
                                                >¿Desea cancelar la nueva encuesta?</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onConfirmCancel"
                                        >Cancelar la encuesta</v-btn>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onContinueSurvey"
                                        >Continuar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar canclación *************************** -->
                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bInvalidData"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Información no válida</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon
                                            >mdi-alert-circle-outline</v-icon
                                        >
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                        >mdi-alert-circle</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs11
                                                    class="justify-center text-center"
                                                    >{{ errorMessage }}</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->

                        <!-- Modal para indicar que no hay casos en el idioma seleccionado: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="errorNoLang"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Error</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon
                                            >mdi-alert-circle-outline</v-icon
                                        >
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                        >mdi-alert-circle</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs11
                                                    class="justify-center text-center"
                                                    >No hay casos en el idioma seleccionado.</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="errorNoLang = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal indicar que no hay cuestionarios en el idioma seleccionado *********************************** -->
                        
                    </v-container>
                    
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'NewSurvey',
    data() {
        return {
            bDense: true,
            bCancelDlg: false,
            bInvalidData: false,
            errorMessage: '',

            dToday: null,
            pLastname: '',
            mLastname: '',
            name: '',
            ageID: 0,
            sexID: 0,
            orgLevelID: 0,
            languageID: 0,
            email: '',
        };
    },
    components: {},
    created()
    {
        this.dToday = new Date();
        var dd = String(this.dToday.getDate()).padStart(2, '0');
        var mm = String(this.dToday.getMonth() + 1).padStart(2, '0');
        var yyyy = this.dToday.getFullYear();
        this.dToday = dd + '/' + mm + '/' + yyyy;
    },
    methods: {
        onStart() {
            var bDataOK = false;

            //Validación de los datos:
            if (this.pLastname === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'Teclee el apellido paterno del encuestado.';
            } else if (this.name === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'Telee el nombre del encuestado.';
            } else if (this.ageID === 0)
            {
                this.bInvalidData = true;
                this.errorMessage = 'Seleccione un rango de edad para el encuestado.';
            } else if (this.sexID === 0)
            {
                this.bInvalidData = true;
                this.errorMessage = 'Seleccione el sexo del encuestado.';
            } else if (this.orgLevelID === 0)
            {
                this.bInvalidData = true;
                this.errorMessage = 'Seleccione el nivel organizacional del encuestado.';
            } else if (this.email === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'Teclee el correo electrónico del encuestado.';
            } else if (this.languageID === 0)
            {
                this.bInvalidData = true;
                this.errorMessage = 'Seleccione un idioma para realizar la encuesta.';
            
            } else {
                bDataOK = true;
            }

            if (bDataOK)
            {
                var survey = {
                    fecha: this.dToday,
                    usuarioid: this.loggedUserID,
                    apaterno: this.pLastname,
                    amaterno: this.mLastname,
                    nombre: this.name,
                    edadid: this.ageID,
                    generoid: this.sexID,
                    nivelorganizacionalid: this.orgLevelID,
                    idiomaid: this.languageID,
                    email: this.email
                }
                this.$store.dispatch('newSurvey', survey);
            }

        },

        onCancel() {
            this.bCancelDlg = true;
        },

        onConfirmCancel() {
            this.bCancelDlg = false;
            this.$router.push('/').catch(err => {});
        },

        onContinueSurvey() {
            this.bCancelDlg = false;
        },
    },
    computed: {
        ...mapGetters(['languages', 'genders', 'organizationalLevels', 'ageRanges','waitCursor', 'userName', 'loggedUserID']),

        errorNoLang: {
            get() {
                return this.$store.getters.errorNoLang;
            },
            set(errorNoLang) {
                this.$store.dispatch('updateErrorNoLang', errorNoLang);
            },
        },

        imgHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '250px';
            } else {
                height = '300px';
            }
            return height;
        },

        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '70px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '100px';
            } else {
                height = '120px';
            }
            return height;
        },

        modalWidth() {
            var width = '90%';
            if (this.$vuetify.breakpoint.xs) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '55%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '45%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '35%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '25%';
            }
            return width;
        },
        
        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },
    },
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.9);
}
.new-survey {
    background: url('../assets/hunters-race-MYbhN8KaaEc-unsplash.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>